"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var Visible = function Visible(props) {
  var condition = props.condition,
      ifTrue = props.ifTrue,
      otherwise = props.otherwise,
      children = props.children;
  return condition ? ifTrue || children : otherwise;
};

Visible.propTypes = {
  condition: _propTypes.default.bool,
  ifTrue: _propTypes.default.node,
  otherwise: _propTypes.default.node,
  children: _propTypes.default.node
};
Visible.defaultProps = {
  otherwise: null
};
Visible.displayName = 'Visible';
var _default = Visible;
exports.default = _default;